/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CheckEmailInput
 */
export interface CheckEmailInput {
    /**
     * 
     * @type {string}
     * @memberof CheckEmailInput
     */
    email?: string;
}

/**
 * Check if a given object implements the CheckEmailInput interface.
 */
export function instanceOfCheckEmailInput(value: object): value is CheckEmailInput {
    return true;
}

export function CheckEmailInputFromJSON(json: any): CheckEmailInput {
    return CheckEmailInputFromJSONTyped(json, false);
}

export function CheckEmailInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckEmailInput {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
    };
}

export function CheckEmailInputToJSON(json: any): CheckEmailInput {
    return CheckEmailInputToJSONTyped(json, false);
}

export function CheckEmailInputToJSONTyped(value?: CheckEmailInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
    };
}

